import React from 'react';

const Loader = () => {
  return (
    <div className="loader">
      <div className="icon icon--loader"></div>
    </div>
  );
}

export default Loader;